module.exports = __webpack_public_path__ + "static/media/goldenprize-tuna-flakes-brine-lid.6801adcc.png";